import { CustomCellRendererProps } from "@ag-grid-community/react";
import Site from "shared/components/DS/Site";

const SiteRenderer = ({value, data}: CustomCellRendererProps) => (
  <Site siteName={value} sid={data.sid}/>)

export default SiteRenderer;
